import { render, staticRenderFns } from "./FormsCreate.vue?vue&type=template&id=082328c6&"
import script from "./FormsCreate.vue?vue&type=script&lang=js&"
export * from "./FormsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports